import { render, staticRenderFns } from "./BuildPhaseAccordionHeader.vue?vue&type=template&id=16e0b400&scoped=true"
import script from "./BuildPhaseAccordionHeader.vue?vue&type=script&lang=ts"
export * from "./BuildPhaseAccordionHeader.vue?vue&type=script&lang=ts"
import style0 from "./BuildPhaseAccordionHeader.vue?vue&type=style&index=0&id=16e0b400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e0b400",
  null
  
)

export default component.exports